<template>
  <nav
    class="nav"
    v-if="displayNav"
  >
    <ul
      class="navigation"
      v-if="!mobile"
    >
      <li
        v-for="(item, index) in items"
        :key="index"
        class="link"
      >
        <template v-if="item.external">
          <a
            :href="item.href"
            target="_blank"
            rel="noopener noreferrer"
            :class="item.class"
          >
            {{ item.description }}
          </a>
        </template>
        <template v-else>
          <router-link
            :to="{ name: item.href, hash: item.hash }"
            :class="item.class"
          >
            {{ item.description }}
          </router-link>
        </template>
      </li>
    </ul>

    <transition name="mobile-nav">
      <ul
        class="mobile-menu dropdown-nav"
        v-if="toggleSideBar"
        ref="mobileMenu"
      >
        <li
          v-for="(item, index) in items"
          :key="index"
          @click="toggleSideBar = false"
        >
          <template v-if="item.external">
            <a
              :href="item.href"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ item.description }}
            </a>
          </template>
          <template v-else>
            <router-link :to="{ name: item.href, hash: item.hash }">
              {{ item.description }}
            </router-link>
          </template>
        </li>
      </ul>
    </transition>

    <div
      class="icon"
      v-show="mobile"
      @click="toggleSideBar = !toggleSideBar"
      :class="{ 'icon-active': toggleSideBar }"
      ref="menuIcon"
    >
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'ItemsList',
  data() {
    return {
      mobile: true,
      toggleSideBar: false,
      displayNav: true,
    }
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },

  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },

  created() {
    window.addEventListener('resize', this.checkscreen)
    this.checkscreen()
  },
  methods: {
    handleClickOutside(event) {
      if (
        this.toggleSideBar &&
        this.$refs.mobileMenu &&
        !this.$refs.mobileMenu.contains(event.target) &&
        this.$refs.menuIcon &&
        !this.$refs.menuIcon.contains(event.target)
      ) {
        this.toggleSideBar = false
      }
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },

    checkscreen() {
      if (window.innerWidth <= 1002) {
        this.mobile = true
        return
      }
      this.mobile = false
      this.toggleSideBar = false
      return
    },
  },
  computed: {
    items: function () {
      return [
        {
          name: 'home',
          href: 'home',
          description: this.$t('message.home'),
          hash: '',
          class: '',
        },
        {
          name: 'nfse',
          href: 'nfse',
          description: 'NFSe',
          hash: '',
          class: '',
        },
        {
          name: 'plans',
          href: 'home',
          description: this.$t('message.plans'),
          hash: '#plans',
          class: '',
        },
        {
          name: 'contact',
          href: 'contact',
          description: this.$t('message.contact'),
          hash: '',
          class: '',
        },
        {
          name: 'faq',
          href: 'faq',
          description: this.$t('message.faq'),
          hash: '',
          class: 'me-5',
        },
        {
          name: 'create-trial-account',
          href: 'https://financeiro.janelaunica.com.br/#/registro',
          description: this.$t('message.createTrialAccount'),
          hash: '',
          class: 'btn btn-primary',
          external: true,
        },
        {
          name: 'login',
          href: 'login',
          description: this.$t('message.login'),
          hash: '',
          class: 'btn btn-',
        },
      ]
    },
  },
}
</script>

<style scoped>
a {
  letter-spacing: 2px;
}
a:hover:not(.btn) {
  border-bottom: 1px solid var(--p2);
}

.nav {
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  font-family: var(--display);
}

.dropdown-nav {
  background: var(--white);
  display: none;
  display: flex;
  flex-direction: column;
  position: fixed;
  max-width: 350px;
  height: 100vh;
  top: 0;
  left: 0;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.dropdown-nav > li {
  display: flex;
  flex-direction: column;
  padding: 0;
}

.dropdown-nav > li > a {
  padding: 14px;
  color: var(--p2);
}

.icon {
  cursor: pointer;
  width: 24px;
  height: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.bar {
  width: 100%;
  height: 2px;
  background-color: var(--white);
  transition: all 0.3s ease;
}

.icon-active .bar:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}

.icon-active .bar:nth-child(2) {
  opacity: 0;
}

.icon-active .bar:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}

.mobile-nav-enter-active,
.mobile-nav-leave-active {
  transition: 1s ease all;
}

.mobile-nav-enter-from,
.mobile-nav-leave-to {
  transform: translateX(-285px);
}

.mobile-nav-enter-to {
  transform: translateX(0);
}

.navigation {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
  margin-bottom: -2px;
}

.navigation > li {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 1rem;
}

.navigation a {
  border-bottom: 1px solid transparent;
  color: var(--c4);
}

.mobile-menu li {
  width: 250px;
}

.btn-white:hover {
  box-shadow: rgba(47, 47, 97, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px,
    rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
  transition: 0.5s ease all;
}

@media (min-width: 1200px) {
  .navigation > li {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    font-size: 1rem;
    font-weight: bold;
  }
}
</style>
